import { Outlet } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import StickyCallCTA from "./StickyCallCTA";

export default function Layout() {
  return (
    <>
      <Nav />
      <main data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <StickyCallCTA />
    </>
  );
}
